import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress cross-origin "Script error." from third-party iframes/scripts
// These are benign errors from embedded content (Twitter, ads, etc.)
window.addEventListener("error", (event) => {
  if (event.message === "Script error." || event.message === "Script error") {
    event.stopImmediatePropagation();
    event.preventDefault();
    return true;
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
